import { render, staticRenderFns } from "./ShareProductModal.vue?vue&type=template&id=32c2803c&"
import script from "./ShareProductModal.vue?vue&type=script&lang=js&"
export * from "./ShareProductModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports